// extracted by mini-css-extract-plugin
export default {"wrapper":"Basic_wrapper__+0KSC","navBlock":"Basic_navBlock__n8WXL","navBlock__title":"Basic_navBlock__title__+ggL4","navBlock__menu":"Basic_navBlock__menu__QhpLi"};